import React from "react";
import { updateData } from "../../utility/managerApi";
import CancelIcon from "@mui/icons-material/Cancel";

function EditSubcategory({
  singleData,
  setSingleData,
  fetchSubcategories,
  setEdittab,
  setLoading,
  currentPage,
}) {
  const handleChange = (e) => {
    const { name, value } = e.target; // Destructure name and value from event target
    setSingleData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    setSingleData((prevData) => ({
      ...prevData,
      cat_id: singleData.cat_id,
    }));

    const keysToExtract = ["cat_id", "sub_cat_name"];
    const newSingleData = Object.keys(singleData).reduce((result, key) => {
      if (keysToExtract.includes(key)) {
        result[key] = singleData[key];
      }
      return result;
    }, {});

    const response = await updateData(
      "sub_categories/update/",
      singleData.id,
      newSingleData
    );
    let errorCheck = response?.response?.data?.error;

    if (errorCheck) {
      setLoading(false);
    } else {
      fetchSubcategories(currentPage);
      setEdittab(false);
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded-md">
      <div className="flex justify-end">
        <CancelIcon onClick={() => setEdittab(false)} />
      </div>

      <h2 className="text-2xl font-medium text-center">Edit Sub-Category </h2>
      <form
        onSubmit={handleEditSubmit}
        className="py-12  flex flex-col justify-center items-center gap-6 "
      >
        <div className="flex flex-col gap-6 ">
          <div className="flex flex-col">
            <label htmlFor="">Category</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="sub Name"
              type="text "
              name="sub_cat_name"
              disabled
              // id="email"
              value={singleData?.category?.cat_name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="">Sub-Category</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="sub Name"
              type="text "
              name="sub_cat_name"
              // id="email"
              value={singleData?.sub_cat_name}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <button
          type="submit"
          className="px-4 py-3 text-white rounded-lg w-full lg:w-[400px] bg-blue-500"
        >
          {/* {loading ? "Saving..." : "Save Product"} */}
          Submit
        </button>
      </form>
    </div>
  );
}

export default EditSubcategory;
